import React, { useEffect, useState } from 'react';
import { Select, message } from 'antd';
import { findAllIesRegisteredEvent } from '../../_events/ies_registered/find.event';
import { filterOption } from '../../_utils/filter_select';

export default function SelectIesRegistered({ value ,setValue = () => {}, allowClear = false }) {

    const [ data, setData ] = useState([]);

    useEffect(() => {
        findAllIesRegisteredEvent()
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            message.error(err.message);
        })
    }, []);

    const onChange = (value) => {
        setValue(value)
    };

    const buildValue = (val) => {
        if(val === undefined || val === null) return '';
        const found = data.find( d => d.uuid === val );
        if(found) return { value: found.uuid, label: `${found.ies?.name} ${found.campus ? 'SEDE ' + found.campus : ''}` };
        else return '';
    }   

    return(
        <Select
            allowClear={allowClear}
            showSearch
            placeholder="Selecciona IES"
            optionFilterProp="children"
            onChange={onChange}
            filterOption={filterOption}
            value={ buildValue(value) }
            options={data.map( d => ({ value: d.uuid, label: `${d.ies?.name} ${d.campus ? 'SEDE ' + d.campus : ''}` }) )}
        />
    );
};